import axios, { AxiosError, type AxiosRequestConfig } from "axios";
import qs from "qs";
import { GRAY_VERSION } from "@zhihaoscm/mo-config";
import { AxiosCanceler } from "@/api/AxiosCanceler";
import { getStatusMessage } from "@/api/checkStatus";
import { getTenantId, handleLoginExpired, handleOffline, notifyRequestError, readToken } from "@/api/runtime";
import type { ApiResponse, InternalRequestConfig } from "@/api/types";

const canceler = new AxiosCanceler();

/** 创建可注入适配器的 Axios 实例，便于测试全部请求合同。 */
export function createHttp(config: AxiosRequestConfig = {}) {
    const service = axios.create({ baseURL: import.meta.env.DEV ? "/custom" : import.meta.env.VITE_API_URL, timeout: 30_000, withCredentials: true, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }), ...config });
    service.interceptors.request.use((request: InternalRequestConfig) => {
        request.headers["X-platform"] = "console";
        request.headers["app-type"] = "1";
        request.headers.Version = GRAY_VERSION;
        const token = readToken(); if (token) request.headers.Authorization = token;
        const tenantId = getTenantId(); if (tenantId && !(request.data as any)?.noNeedTenantId) request.headers.tenantId = tenantId;
        if (request.cancel) canceler.add(request);
        return request;
    });
    service.interceptors.response.use((response): any => {
        const payload = response.data as ApiResponse<unknown>;
        if (payload.code && payload.code !== "0") { if (!(response.config as InternalRequestConfig).silentError) notifyRequestError(payload.message ?? "请求失败！"); return Promise.reject(payload); }
        return payload;
    }, (error: AxiosError) => {
        const request = error.config as InternalRequestConfig | undefined;
        if (error.response?.status === 401) { handleLoginExpired(); return Promise.reject(error); }
        if (!request?.silentError) {
            if (error.message.includes("timeout")) notifyRequestError("请求超时！请您稍后重试");
            else if (error.message.includes("Network Error")) notifyRequestError("网络错误！请您稍后重试");
            else if (error.response) notifyRequestError(getStatusMessage(error.response));
        }
        if (!window.navigator.onLine) handleOffline();
        return Promise.reject(error);
    });
    return service;
}

export const requestHttp = createHttp();
export const dataServiceHttp = createHttp({ baseURL: import.meta.env.DEV ? "/dataService/custom" : import.meta.env.VITE_API_URL?.replace(/\/custom\/?$/, "/dataService/custom") });
